"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var KeyboardInterceptor = /*#__PURE__*/function () {
  function KeyboardInterceptor() {
    var _this = this;

    _classCallCheck(this, KeyboardInterceptor);

    this.container = void 0;
    this.config = void 0;
    this.fallbackCb = void 0;

    this.handleKeyPress = function (event) {
      event.preventDefault();
      var code = event.code;
      var key = event.key;
      var callback = _this.config[code] || _this.config[key] || _this.fallbackCb;
      callback(event);
    };
  }

  _createClass(KeyboardInterceptor, [{
    key: "setup",
    value: function setup(ref, config, fallbackCb) {
      this.container = ref;
      this.config = config;
      this.fallbackCb = fallbackCb;
      this.container.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this.container.removeEventListener('keydown', this.handleKeyPress);
    }
  }]);

  return KeyboardInterceptor;
}();

exports["default"] = KeyboardInterceptor;
//# sourceMappingURL=KeyboardInterceptor.js.map